<tr>
  <td>
    <span class="rt-grip rt-act" draggable="true" (dragstart)="aloitaRivinRaahaus($event)" (dragend)="lopetaRivinRaahaus()" [attr.title]="'lasku.siirra-rivia' | translate | async">
      <mat-icon>drag_indicator</mat-icon>
    </span>
  </td>
  <td>
    <div class="rt-desc">
      <button type="button" tabindex="-1" class="rt-cube" [class.ei-kaytossa]="!rekisterivalintaKaytossa" [matTooltip]="'lasku.rekisteri.' + kuutionTila | translate | async" [matTooltipDisabled]="!rekisterivalintaKaytossa" matTooltipPosition="above" [attr.aria-label]="'lasku.rekisteri.' + kuutionTila | translate | async" (click)="vaihdaRekisteriinTallennus()">
        <app-kuutio-ikoni [tila]="kuutionTila"></app-kuutio-ikoni>
      </button>
      <div>
        <input #nimiInput class="rt-name" [formField]="parent.nimi" [placeholder]="'lasku.tuote-kuvaus' | translate | async" [attr.aria-label]="'lasku.tuote-kuvaus' | translate | async" (keydown.enter)="siirryRivinSeuraavaanKenttaan('nimi', $event)" (blur)="merkitseTuotteenNimiKosketetuksi()" data-lpignore="true" />
        @if (naytetaankoRivinTarkenne) {
          <div class="rt-det">
            <input #tarkenneInput [formField]="parent.tarkenne" [placeholder]="'lasku.lisaa-tarkenne' | translate | async" [attr.aria-label]="'lasku.lisaa-tarkenne' | translate | async" (keydown.enter)="siirryRivinSeuraavaanKenttaan('tarkenne', $event)" data-lpignore="true" />
          </div>
        }
      </div>
    </div>
  </td>
  @if (naytaProjektit) {
    <td>
      <div class="rt-cell rt-projc">
        <select [formField]="parent.projektiAvain" [class.ph]="!parent.projektiAvain().value()" [attr.aria-label]="'lasku.projekti' | translate | async">
          <option value="">Ei projektia</option>
          @for (projekti of projektit; track projekti.avain) {
            <option [value]="projekti.avain">{{ projekti.nimi }}</option>
          }
        </select>
      </div>
    </td>
  }
  <td class="r">
    <div class="rt-qty">
      <input #maaraInput decimalNumberField [numberOfDecimals]="4" [formField]="parent.maara" [attr.aria-label]="'lasku.maara' | translate | async" (keydown)="kasitteleMaarakentanNappainpainallus($event)" />
      @if (yksikonHakuAuki()) {
        <app-yksikko-haku [yksikko]="parent.yksikko().value()" (yksikkoValittu)="valitseYksikko($event)" (suljettu)="suljeYksikonHaku()"></app-yksikko-haku>
      } @else {
        <select #yksikkoSelect class="rt-unit" [formField]="parent.yksikko" [attr.aria-label]="'lasku.yksikko' | translate | async" (keydown.enter)="siirryRivinSeuraavaanKenttaan('yksikko', $event)">
          @for (yksikko of rivinYksikkoVaihtoehdot(); track yksikko) {
            <option [value]="yksikko" [selected]="yksikko === parent.yksikko().value()">{{ yksikko }}</option>
          }
          <option disabled>──</option>
          <option [value]="yksikonHakuvalinta">{{ 'lasku.yksikko-hae' | translate | async }}</option>
        </select>
      }
    </div>
  </td>
  <td class="r">
    <div class="rt-cell">
      <input #ahintaInput decimalNumberField [numberOfDecimals]="2" [formField]="parent.ahinta" [placeholder]="0 | lmoney: laskunValuutta | async" [attr.aria-label]="'lasku.a-hinta-veroton' | translate | async" (keydown.enter)="siirryRivinSeuraavaanKenttaan('ahinta', $event)" />
    </div>
  </td>
  <td>
    <div class="rt-cell" [attr.title]="alvinLukituksenSelite ? (alvinLukituksenSelite.kaannosavain | translate: { myynninLaji: ('myynnin-laji.' + alvinLukituksenSelite.myynninLaji | translate | async) } | async) : null">
      <select #alvSelect [formField]="parent.alvTunniste" (blur)="parent.alv().markAsTouched()" [attr.aria-label]="'lasku.rivit.alv' | translate | async" (keydown.enter)="siirryRivinSeuraavaanKenttaan('alv', $event)">
        @for (alv of alvt; track alv.tunniste) {
          <option [value]="alv.tunniste">{{ alv.prosentti | ldecimal: 2 | async }} %</option>
        }
      </select>
    </div>
  </td>
  @if (naytaAlennus) {
    <td class="r">
      <div class="rt-cell">
        <input #aleInput decimalNumberField [numberOfDecimals]="4" [formField]="parent.ale" placeholder="–" [attr.aria-label]="'lasku.rivit.alennus' | translate | async" (keydown.enter)="siirryRivinSeuraavaanKenttaan('ale', $event)" />
      </div>
    </td>
  }
  <td class="r rt-sum-cell">{{ parent.yhteensa().value() | lmoney: laskunValuutta | async }}</td>
  <td>
    <span class="rt-dots">
      <button type="button" class="ibtn rt-act" (click)="avaaTaiSuljeRivinValikko()" [attr.aria-label]="'lasku.rivin-toiminnot' | translate | async">
        <mat-icon>more_vert</mat-icon>
      </button>
      @if (rivinValikkoOnAuki()) {
        <div class="rt-menu">
          <button type="button" (click)="lisaaAlennus()">
            <mat-icon>percent</mat-icon>
            {{ 'lasku.lisaa-alennus' | translate | async }}
          </button>
          <button type="button" (click)="monistaRivi()">
            <mat-icon>content_copy</mat-icon>
            {{ 'lasku.monista-rivi' | translate | async }}
          </button>
          <button type="button" class="danger" (click)="poistaRivi()">
            <mat-icon>delete</mat-icon>
            {{ 'lasku.poista-rivi' | translate | async }}
          </button>
        </div>
      }
    </span>
  </td>
</tr>
@if (naytetaankoVerottomuudenPeruste) {
  <tr class="rt-sub">
    <td></td>
    <td [attr.colspan]="sarakkeita - 1">
      <div class="rt-desc">
        <span class="rt-cube-sp"></span>
        <select class="rt-basis" [class.warn]="!parent.verottomuudenPeruste().value()" [formField]="parent.verottomuudenPeruste" [attr.aria-label]="'lasku.verottomuuden-peruste' | translate | async">
          <option value="">{{ 'lasku.verottomuuden-peruste' | translate | async }}</option>
          @for (peruste of verottomanMyynninPerusteet; track peruste) {
            <option [value]="peruste">{{ 'verottoman-myynnin-peruste.' + peruste | translate | async }}</option>
          }
        </select>
      </div>
    </td>
  </tr>
}
